import moment from 'jalali-moment'

/**
 * One month from today, as the Gregorian `YYYY-MM-DD` the API expects.
 *
 * The previous implementation round-tripped through
 * `date.toLocaleDateString()` and `moment.from(value, 'YYYY-MM-DD')`, which
 * held two bugs in one line:
 *
 *   1. `toLocaleDateString()` follows the DEVICE locale. On an en-US phone it
 *      returns «8/30/2026»; on a Persian one it returns «۱۴۰۵/۶/۸».
 *   2. jalali-moment's `from` takes `(input, locale, format)` — so
 *      'YYYY-MM-DD' was being passed as the LOCALE and no format was ever
 *      applied. The en-US string only survived via moment's deprecated
 *      `new Date(string)` fallback.
 *
 * On a Persian-locale device the result was the literal string
 * "Invalid date", which the API rejected with
 * `{"due_date": ["Date has wrong format..."]}` and the PWA surfaced as
 * «خطایی رخ داده» — blocking every loan grant that left the optional
 * «تاریخ شروع اقساط» empty.
 *
 * Formatting straight off moment needs neither the device locale nor a parse.
 * `.locale('en')` is set BEFORE `.add` so the month is a Gregorian one, which
 * is what the old `date.setMonth(+1)` meant.
 */
export const getOneMonthLater = () =>
    moment().locale('en').add(1, 'month').format('YYYY-MM-DD')
